import UIHelper from 'general/helpers/UIHelper';
import useRouter from 'hooks/useRouter';
import EnergyBillInvoiceDetailView from '../../components/EnergyBillInvoiceDetailView';

EnergyBillInvoiceDetailScreen.propTypes = {};

function EnergyBillInvoiceDetailScreen(props) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const billId = router.query.billId;
  const stationId = router.query.stationId;
  const month = router.query.month;

  return (
    <div>
      {/* breadcrumb */}
      <div>
        {UIHelper.buildBreadcrumb([
          {
            title: 'Danh sách hóa đơn tiền điện',
            onPress: () => {
              router.navigate(-2);
            },
          },
          {
            title: 'Chi tiết hóa đơn tiền điện trạm sạc',
          },
        ])}
      </div>
      <div className="px-4 my-4">
        <EnergyBillInvoiceDetailView billId={billId} stationId={stationId} month={month} />
      </div>
    </div>
  );
}

export default EnergyBillInvoiceDetailScreen;
